module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAUCAYAAACJfM0wAAAASElEQVQ4jWP8DwQMNABMtDCUpgaz4JO0dQlmePX6DYqYmKgIw+E9awkazDgaxjCAEsbYwpQQwBXmo2EMB6PpmPYGj6bjIWwwAKR7LBjhH+bqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jztb1-1.png
// module id = 412
// module chunks = 0